import React from 'react';
import { render, screen, fireEvent } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';
import AppsLinks from 'components/layouts/ManagementLayout/AppsLinks';

const LINKS = [
  {
    id: 'portal-DCV1',
    kind: 'portal',
    label: 'DECISIV PORTAL',
    url: 'http://portal.dcv.decisiv.test',
  },
  {
    id: 'insite',
    kind: 'insite',
    label: 'Insite',
    url: 'https://analytics.decisivapps.com/bi/login.html',
  },
];

const renderAppsLinks = (props = {}) =>
  render(
    <ConfigProvider>
      <AppsLinks links={LINKS} {...props} />
    </ConfigProvider>,
  );

describe('AppsLinks', () => {
  it('renders the switcher button', () => {
    renderAppsLinks();

    expect(
      screen.getByRole('button', { name: 'Show Apps links' }),
    ).toBeInTheDocument();
  });

  // Regression: the blue block must span the whole 56px bar. It previously
  // collapsed because the nav section centred its children.
  it('fills the full height of the top bar', () => {
    renderAppsLinks();

    expect(
      screen.getByRole('button', { name: 'Show Apps links' }),
    ).toHaveStyleRule('height', '100%');
  });

  it('renders nothing when there are no links', () => {
    renderAppsLinks({ links: [] });

    expect(
      screen.queryByRole('button', { name: 'Show Apps links' }),
    ).not.toBeInTheDocument();
  });

  it('lists each link once the popover is open', () => {
    renderAppsLinks();

    fireEvent.click(screen.getByRole('button', { name: 'Show Apps links' }));

    expect(screen.getByText('DECISIV PORTAL')).toBeInTheDocument();
    expect(screen.getByText('Insite')).toBeInTheDocument();
  });

  it('opens the selected link in a new tab', () => {
    const open = jest.spyOn(window, 'open').mockImplementation(() => {});

    renderAppsLinks();
    fireEvent.click(screen.getByRole('button', { name: 'Show Apps links' }));
    fireEvent.click(screen.getByText('DECISIV PORTAL'));

    expect(open).toHaveBeenCalledWith(
      'http://portal.dcv.decisiv.test',
      '_blank',
      'noopener,noreferrer',
    );

    open.mockRestore();
  });
});
